<template>
  <a-modal
    v-model="visible"
    :title="title"
    width="20cm"
    :destroyOnClose="true"
    :maskClosable="false"
    @ok="handleSubmit">
    <a-form
      id="formPassword"
      ref="formPassword"
      :form="form"
    >
      <a-form-item label="用户名" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
        <a-input
          size="large"
          type="text"
          disabled
          v-model="operator.no"
        >
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>
      <a-form-item label="旧密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
        <a-input-password
          size="large"
          type="text"
          placeholder="请输入旧密码"
          v-model="oldPass"
        >
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input-password>
      </a-form-item>
      <a-form-item label="新密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
        <a-input-password
          size="large"
          type="text"
          placeholder="请输入新密码"
          v-model="newPass"
        >
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input-password>
      </a-form-item>
      <a-form-item label="确认新密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
        <a-input-password
          size="large"
          type="text"
          placeholder="请再次输入新密码"
          v-model="newPass2"
        >
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input-password>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
    import api from '@/api';
    import {post} from '@/api/Api';
    import {checkFieldType} from '@/utils/field-check'

  export default {
    name: 'PasswordModify',
    data() {
      return {
        oldPass: '',
        newPass: '',
        newPass2: '',
        visible: false,
        title: '密码修改',
        form: this.$form.createForm(this)
      }
    },
    props: {
      'operator': {
        type: Object,
        default: null
      }
    },
    methods: {
      handleSubmit() {
        const map = new Map()
        map.set('username', this.operator.no)
        map.set('password', this.oldPass)
        map.set('newPassword', this.newPass2)
        const returnValue = checkFieldType(map)
        post(api.adminAuthChangePassword, {}, returnValue)
          .then((res) => {
            this.$message.success(res)
          })
        this.visible = false
      }
    }
  }
</script>

<style scoped>

</style>